import React from 'react';
import { useTempAlertStore } from './store/portal/tempAlertStore';
import TempAlert from '../portal/TempAlert';
import TempAlertComp from '../component/tempAlert/TempAlertComp';


const TempAlertTemplate: React.FC = () => {
  const { tempAlert } = useTempAlertStore();

  if (tempAlert === null) return null;

  return (
    <TempAlert>
      <TempAlertComp />
    </TempAlert>
  );
};


export default TempAlertTemplate;
